import { IFeedback } from '../@types/Feedback';
import apiClient from './apiClient';

export const provideFeedback = async (docID, feedback: IFeedback[]) => {
    return apiClient
        .post(`/feedback?doc_id=${docID}`, feedback)
        .then((res) => res.data)
        .catch((err) => Promise.reject({ ...err }));
};
